module.exports = __webpack_public_path__ + "static/img/new_about2.e7b77fc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images_new/new_about2.png
// module id = xCsq
// module chunks = 1